import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { PolicyQrSelectorComponent } from '../policy-qr-selector/policy-qr-selector.component';
import { PolicyQrDisplayComponent } from '../policy-qr-display/policy-qr-display.component';
import { QrService } from '../../core/services/qr.service';

@Component({
  selector: 'app-qr-button',
  standalone: true,
  imports: [
    CommonModule,
    PolicyQrSelectorComponent,
    PolicyQrDisplayComponent
  ],
  template: `
    <!-- Floating QR button removed — the QR selector is now opened from the
         home "ບັດ QR" quick action via QrService. This component only hosts
         the QR modals so they remain available app-wide. -->

    @if (showQrSelector) {
      <app-policy-qr-selector
        (policySelected)="onPolicySelected($event)"
        (closed)="closeQrSelector()">
      </app-policy-qr-selector>
    }

    @if (showQrDisplay) {
      <app-policy-qr-display
        [policyData]="selectedPolicy"
        (closed)="closeQrDisplay()">
      </app-policy-qr-display>
    }
  `,
  styles: [`
    :host { display: block; }
  `]
})
export class QrButtonComponent implements OnInit, OnDestroy {
  showQrSelector = false;
  showQrDisplay = false;
  selectedPolicy: any = null;
  private openSub?: Subscription;

  constructor(private qrService: QrService) {}

  ngOnInit(): void {
    // Open the QR selector when the home "ບັດ QR" quick action requests it.
    this.openSub = this.qrService.open$.subscribe(() => this.openQrSelector());
  }

  ngOnDestroy(): void {
    this.openSub?.unsubscribe();
  }

  /** Open QR code selector. */
  openQrSelector(): void {
    this.showQrSelector = true;
  }

  /** Handle policy selection from QR selector. */
  onPolicySelected(policy: any): void {
    // Only open QR display if a valid policy was selected.
    if (policy && policy.applicationNo) {
      this.selectedPolicy = policy;
      this.showQrSelector = false;
      this.showQrDisplay = true;
    } else {
      this.showQrSelector = false;
    }
  }

  /** Close QR selector. */
  closeQrSelector(): void {
    this.showQrSelector = false;
  }

  /** Close QR display. */
  closeQrDisplay(): void {
    this.showQrDisplay = false;
    this.selectedPolicy = null;
  }
}
